var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-base",class:{
    'icon-base_red': _vm.red,
    'icon-base_dark-red': _vm.darkRed,
    'icon-base_black': _vm.black,
    'icon-base_white': _vm.white,
    'icon-base_gray': _vm.gray,
    'icon-base_blue': _vm.blue,
    'icon-base_light-blue': _vm.lightBlue,
    'icon-base_green': _vm.green,
    'icon-base_orange': _vm.orange,
  }},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e63d45","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uikit/IconBase.vue
// module id = null
// module chunks = 